import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { canadaGibsonFont } from "../Config";

export default function RHFTextField({ name, control, defaultValue = "", errors, ...muiProps }) {
    const fieldError = name.split(".").reduce((obj, key) => obj?.[key], errors);

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={(field, fieldState) => {
                return (
                    <TextField
                        {...field}
                        {...muiProps}
                        error={!!fieldState.invalid}
                        helperText={fieldError?.message}
                        sx={canadaGibsonFont}
                    />
                );
            }}
        />
    );
}
